/* Ficha de producto en Shopify (Claude Code, 2026-10-05). Los textos, fotos y precios están en
   las secciones (editables); esto elige los precios de campaña por fecha, calcula cuándo llega,
   y maneja la barra de compra y las unidades que vienen en el enlace (?u=2). */
function fichaAntes() {
  const raiz = document.querySelector('[data-ficha]');
  if (!raiz) return;
  /* Precios de campaña hasta la fecha que dice la sección; después, los normales. */
  const hasta = Date.parse(raiz.dataset.campanaHasta || '');
  const enCampana = !isNaN(hasta) && Date.now() < hasta;
  const sets = [...raiz.querySelectorAll('.p-packs[data-set]')];
  const elegido = sets.find((s) => s.dataset.set === (enCampana ? 'campana' : 'normal')) || sets[0];
  sets.forEach((s) => { if (s !== elegido) s.remove(); });
  const linea = raiz.querySelector('.pd-info [data-disc-price]');
  const precio = raiz.querySelector('.pd-info [data-precio]');
  const es2x1 = elegido && elegido.dataset.es2x1 === 'true';
  if (elegido) {
    const uno = +elegido.dataset.uno;
    if (precio) precio.textContent = clp(uno);
    const barra = raiz.querySelector('[data-bar-precio]');
    if (barra) barra.textContent = clp(uno);
    if (linea) {
      linea.dataset.discPrice = uno;
      linea.dataset.extra = elegido.dataset.extra;
      if (elegido.dataset.sinPremio) linea.setAttribute('data-sin-premio', ''); else linea.removeAttribute('data-sin-premio');
    }
  }
  const sello = raiz.querySelector('[data-sello-2x1]');
  if (sello) sello.hidden = !es2x1;
  document.querySelectorAll('[data-solo-2x1]').forEach((el) => { el.hidden = !es2x1; });

  /* Textos vacíos en el editor: siguen a la campaña activa y a las fechas reales. */
  const cd = raiz.querySelector('[data-campana-nombre]');
  if (cd && !cd.textContent.trim()) cd.textContent = `${STORE.offerName}: termina en`;
  const ll = raiz.querySelector('[data-llegada]');
  if (ll && !ll.textContent.trim()) {
    const suma = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) k++; } return d; };
    const dia = (d) => d.toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' });
    const pl = ll.dataset.plantilla || 'Pídelo hoy y en Santiago te llega entre el <b>{desde}</b> y el <b>{hasta}</b>. <span>A regiones, hasta el {regiones}.</span>';
    ll.innerHTML = pl.replace('{desde}', dia(suma(+ll.dataset.rmMin))).replace('{hasta}', dia(suma(+ll.dataset.rmMax))).replace('{regiones}', dia(suma(+ll.dataset.regMax)));
  }
}

function fichaDespues() {
  const el = document.querySelector('[data-ficha]');
  if (!el) return;
  const ocultarReleasitFlotante = () => {
    document.querySelectorAll('.rsi_floating, [id="rsi_buy_now_button"].rsi_floating').forEach((botonFlotante) => {
      botonFlotante.hidden = true;
      botonFlotante.style.setProperty('display', 'none', 'important');
    });
  };
  ocultarReleasitFlotante();
  new MutationObserver(ocultarReleasitFlotante).observe(document.body, { childList: true, subtree: true });
  /* Barra de compra: en el celular siempre; en el computador, solo si el botón no se ve. */
  const bar = el.querySelector('.pd-buybar'), boton = el.querySelector('.pd-comprar'), precio = el.querySelector('.pd-info [data-precio]');
  if (bar && boton && precio) {
    const barPrecio = bar.querySelector('[data-bar-precio]'), barUds = bar.querySelector('[data-bar-uds]');
    const copia = () => {
      if (barPrecio) barPrecio.textContent = precio.textContent;
      if (!barUds) return;
      const ops = [...el.querySelectorAll('.p-packs [data-pack]')];
      const i = ops.findIndex((o) => o.classList.contains('on'));
      barUds.textContent = i > 0 ? `${i + 1} u. · ` : '';
    };
    new MutationObserver(copia).observe(precio, { childList: true, characterData: true, subtree: true });
    el.querySelectorAll('.p-packs [data-pack]').forEach((o) => o.addEventListener('click', () => setTimeout(copia, 0)));
    copia();
    const pon = (v) => { bar.classList.toggle('show', v); bar.setAttribute('aria-hidden', !v); document.body.classList.toggle('has-buybar', v); };
    const observados = new Map();
    const decide = () => pon(![...observados.values()].every(Boolean));
    const observador = new IntersectionObserver((entradas) => {
      entradas.forEach((entrada) => observados.set(entrada.target, entrada.isIntersecting));
      decide();
    }, { rootMargin: '0px 0px -90px 0px', threshold: 0.01 });
    const observarBotonPrincipal = () => {
      const principales = [boton, ...el.querySelectorAll('#rsi_buy_now_button:not(.rsi_floating)')];
      principales.forEach((principal) => {
        if (!observados.has(principal)) {
          observados.set(principal, false);
          observador.observe(principal);
        }
      });
      decide();
    };
    observarBotonPrincipal();
    new MutationObserver(observarBotonPrincipal).observe(el, { childList: true, subtree: true });
  }
  const barraCod = el.querySelector('[data-rsi-proxy]');
  if (barraCod && !barraCod.dataset.bound) {
    barraCod.dataset.bound = 'true';
    barraCod.addEventListener('click', () => {
      const releasit = document.querySelector('#rsi_buy_now_button:not(.rsi_floating), .rsi_buy_now_button:not(.rsi_floating), ._rsi-buy-now-button:not(.rsi_floating)');
      if (releasit) {
        releasit.click();
      } else {
        const hook = document.querySelector('._rsi-buy-now-button-form-block-hook');
        hook?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        let intentos = 0;
        const esperarReleasit = window.setInterval(() => {
          const boton = document.querySelector('#rsi_buy_now_button:not(.rsi_floating), .rsi_buy_now_button:not(.rsi_floating), ._rsi-buy-now-button:not(.rsi_floating)');
          if (boton) { window.clearInterval(esperarReleasit); boton.click(); }
          else if (++intentos >= 20) window.clearInterval(esperarReleasit);
        }, 150);
      }
    });
  }
  /* Sin ?u= abre en 2 unidades (con el 2x1, una cuesta lo mismo que dos); ?u=1 respeta el 1. */
  let u = 2;
  try { const q = new URLSearchParams(location.search).get('u'); if (q !== null) u = +q || 1; } catch (e) { /* sin URL */ }
  const ops = [...el.querySelectorAll('.p-packs [data-pack]')];
  if (u >= 2 && ops[u - 1]) requestAnimationFrame(() => ops[u - 1].click());
}
